import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import { useToastContext } from '../App';

function RulesEditor() {
  const [rules, setRules] = useState(null);
  const [form, setForm] = useState({ title: '', content: '' });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const addToast = useToastContext();

  useEffect(() => {
    loadRules();
  }, []);

  async function loadRules() {
    try {
      const data = await api.getRules();
      setRules(data);
      setForm({ title: data.title || '', content: data.content || '' });
    } catch (e) {
      addToast('Regeln konnten nicht geladen werden', 'error');
    } finally {
      setLoading(false);
    }
  }

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const data = await api.updateRules(form);
      setRules(data);
      addToast('Regeln gespeichert', 'success');
    } catch (e) {
      addToast(e.message, 'error');
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return <div className="empty-state"><div className="spinner" /></div>;
  }

  return (
    <div>
      <div className="page-header">
        <h2>Regeln bearbeiten</h2>
      </div>

      <div className="card">
        <p className="text-sm text-muted" style={{ marginBottom: 16 }}>
          Dieser Text wird Spielern auf der "Regeln &amp; Info"-Seite angezeigt.
          Zeilenumbrueche werden uebernommen.
        </p>
        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>Titel</label>
            <input
              className="form-input"
              value={form.title}
              onChange={e => setForm({ ...form, title: e.target.value })}
              placeholder="Server-Regeln & Informationen"
            />
          </div>
          <div className="form-group">
            <label>Inhalt</label>
            <textarea
              className="form-input"
              value={form.content}
              onChange={e => setForm({ ...form, content: e.target.value })}
              placeholder="Regeln und Informationen fuer die Spieler..."
              rows={20}
              style={{ resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>
          <div className="flex gap-2">
            <button className="btn btn-primary" type="submit" disabled={saving}>
              {saving ? <span className="spinner" /> : 'Speichern'}
            </button>
            {rules && (
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => setForm({ title: rules.title || '', content: rules.content || '' })}
              >
                Zuruecksetzen
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Preview */}
      <div className="card" style={{ marginTop: 24 }}>
        <h3 style={{ marginBottom: 12 }}>Vorschau</h3>
        <div style={{ border: '3px solid var(--mc-coal)', padding: 16, background: 'rgba(0,0,0,0.2)' }}>
          <h3 style={{ color: 'var(--mc-gold)', marginBottom: 12 }}>
            {form.title || 'Kein Titel'}
          </h3>
          <div style={{ whiteSpace: 'pre-wrap', color: 'var(--text-primary)', lineHeight: '1.6' }}>
            {form.content || 'Kein Inhalt'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RulesEditor;
